import { render, staticRenderFns } from "./CreatePostPage.vue?vue&type=template&id=4ab0e25a&scoped=true&"
import script from "./CreatePostPage.vue?vue&type=script&lang=js&"
export * from "./CreatePostPage.vue?vue&type=script&lang=js&"
import style0 from "./CreatePostPage.vue?vue&type=style&index=0&id=4ab0e25a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab0e25a",
  null
  
)

export default component.exports